// test2118
(2118 && 0);
